// 左栏单个 Room 项 —— 头像 + 名 + 最后消息预览 + 时间 + 未读徽章

import { NavLink } from "react-router-dom";

import { Avatar } from "./Avatar";
import { UnreadBadge } from "./UnreadBadge";

export interface RoomSummary {
  id: string;
  name: string;
  lastMessage: string;
  lastTs: string;
  unread?: number;
  hasMention?: boolean;
}

interface RoomCardProps {
  room: RoomSummary;
}

export function RoomCard({ room }: RoomCardProps) {
  return (
    <NavLink
      to={`/rooms/${room.id}`}
      className={({ isActive }) =>
        isActive ? "room-card room-card--active" : "room-card"
      }
    >
      <Avatar seed={room.id} label={room.name} size={40} />
      <div className="room-card__main">
        <div className="room-card__head">
          <span className="room-card__name">{room.name}</span>
          <time className="room-card__ts">{room.lastTs}</time>
        </div>
        <div className="room-card__preview">
          <span className="room-card__msg">{room.lastMessage}</span>
          <UnreadBadge count={room.unread ?? 0} mention={room.hasMention} />
        </div>
      </div>
    </NavLink>
  );
}
